module.exports = __webpack_public_path__ + "img/20260603_pengfeiwang.c0c91a6b.jpg";